const getLocalStorage = (...args) => {
  let storage = {};
  for (let arg of args) {
    storage[arg] = window.localStorage.getItem(arg) || "";
  }
  return storage;
};

const setLocalStorage = data => {
  for (let prop in data) {
    window.localStorage.setItem(prop, data[prop]);
  }
};

const removeLocalStorage = (...args) => {
  for (let arg of args) {
    window.localStorage.removeItem(arg);
  }
};

const debounce = (func, wait, immediate) => {
  let timeout, args, context, timestamp, result;
  return function () {
    context = this;
    args = arguments;
    timestamp = new Date();
    const later = () => {
      const last = new Date() - timestamp;
      if (last < wait) {
        timeout = setTimeout(later, wait - last);
      } else {
        timeout = null;
        result = func.apply(context, args);
      }
    };
    if (!timeout) {
      timeout = setTimeout(later, wait);
    }
    return result;
  };
};
const throttle = (func, wait, options) => {
  var timeout, context, args, result;
  var previous = 0;
  if (!options) options = {};

  var later = function () {
    previous = options.leading === false ? 0 : new Date();
    timeout = null;
    result = func.apply(context, args);
    if (!timeout) context = args = null; //显示地释放内存，防止内存泄漏
  };

  var throttled = function () {
    var now = new Date();
    if (!previous && options.leading === false) previous = now;
    var remaining = wait - (now - previous);
    context = this;
    args = arguments;
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      previous = now;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining);
    }
    return result;
  };

  throttled.cancel = function () {
    clearTimeout(timeout);
    previous = 0;
    timeout = context = args = null;
  };

  return throttled;
};

const getLocationParam = function (name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return decodeURIComponent(r[2]);
  return "";
};

export {
  getLocalStorage,
  setLocalStorage,
  removeLocalStorage,
  getLocationParam,
  debounce,
  throttle
};

export default {
  install(Vue) {
    Object.defineProperties(Vue.prototype, {
      $util: {
        value: {
          getLocalStorage,
          setLocalStorage,
          removeLocalStorage,
          getLocationParam,
          debounce,
          throttle
        }
      }
    });
  }
};
/* 生成当前时间戳对应的62进制形式短链接 */
export const shorten = function () {
  var DIGITS = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
  var seq = new Date().getTime();
  var len = DIGITS.length;
  var arr = [];
  do {
    arr.unshift(DIGITS.charAt(seq % len));
    seq = parseInt(seq / len);
  } while (seq !== 0);
  return arr.join("");
};

export function formatPrice(price) {
  price = parseFloat(price);
  return parseFloat(price.toFixed(2));
}

export function formatTimestamp(timestamp, format = "YYYY-MM-DD HH:mm:ss") {
  const date = new Date(timestamp);
  const pad = num => String(num).padStart(2, "0");
  const replacements = {
    YYYY: date.getFullYear(),
    MM: pad(date.getMonth() + 1),
    DD: pad(date.getDate()),
    HH: pad(date.getHours()),
    mm: pad(date.getMinutes()),
    ss: pad(date.getSeconds())
  };
  return format.replace(/YYYY|MM|DD|HH|mm|ss/g, match => replacements[match]);
}

function isWeixin() {
  let userAgent = navigator.userAgent;
  if (userAgent.indexOf('MicroMessenger') > -1) {
    return true;
  } else {
    return false;
  }
}
export const is_weixin = isWeixin();

/** 判断是否为手机号（1 开头） */
export const isPhoneNumber = (str) => {
  const reg = /^(?:(?:\+|00)86)?1\d{10}$/
  return reg.test(str)
}

export const checkPassword = (newPwd, confirmPwd) => {
  const result = {
    isSame: false,
    isLengthValid: false,
    isCharTypeValid: false,
    isAllValid: false,
    message: {
      same: "",
      length: "",
      charType: "",
      total: "",
    },
  };

  if (newPwd.trim() === "" || confirmPwd.trim() === "") {
    result.message.same = "新密码或确认密码不能为空";
  } else if (newPwd !== confirmPwd) {
    result.message.same = "新密码与确认密码不一致，请重新输入";
  } else {
    result.isSame = true;
    result.message.same = "新密码与确认密码一致";
  }

  const pwdTrimmed = newPwd.trim();

  if (pwdTrimmed.length === 0) {
    result.message.length = "请先输入密码";
  } else if (pwdTrimmed.length <= 8) {
    result.message.length =
      "密码长度需大于8位（当前长度：" + pwdTrimmed.length + "位）";
  } else {
    result.isLengthValid = true;
    result.message.length = "密码长度符合要求（大于8位）";
  }

  const charRules = [
    { type: "英文大写", regex: /[A-Z]/ },
    { type: "英文小写", regex: /[a-z]/ },
    { type: "数字", regex: /\d/ },
    { type: "特殊字符", regex: /[^0-9a-zA-Z]/ },
  ];

  let validCharTypes = [];
  charRules.forEach((rule) => {
    if (rule.regex.test(pwdTrimmed)) {
      validCharTypes.push(rule.type);
    }
  });

  if (pwdTrimmed.length === 0) {
    result.message.charType = "请先输入密码";
  } else if (validCharTypes.length < 3) {
    result.message.charType = `密码需至少包含3种字符（大写、小写、数字、特殊字符），当前包含${
      validCharTypes.length
    }种：${validCharTypes.join("、")}`;
  } else {
    result.isCharTypeValid = true;
    result.message.charType = `密码字符类型符合要求（包含${
      validCharTypes.length
    }种字符：${validCharTypes.join("、")}）`;
  }

  result.isAllValid =
    result.isSame && result.isLengthValid && result.isCharTypeValid;
  result.message.total = result.isAllValid
    ? "密码校验通过，可以使用"
    : "密码校验未通过，请根据上述提示修正";

  return result;
};
